export default __webpack_public_path__ + "f241ac5a509d791529ad41d49978ded7.gif";